import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

// Maps a NavigationStore item key to a route path and back.
export const NAV_ROUTES = [
  { key: "dashboard", path: "/" },
  { key: "surveys", path: "/surveys" },
  { key: "reports", path: "/reports" },
  { key: "create", path: "/new-survey" },
  { key: "company", path: "/company" },
  { key: "settings", path: "/settings" },
];

const routes = [
  ...NAV_ROUTES.map((r) => ({ path: r.path, name: r.key, meta: { navKey: r.key } })),
  // Deep link into a specific survey; opens the Surveys view then the survey.
  { path: "/surveys/:id", name: "survey-detail", meta: { navKey: "surveys" } },
  // Fallback to dashboard for unknown paths.
  { path: "*", redirect: "/" },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export function pathForNavKey(key) {
  const match = NAV_ROUTES.find((r) => r.key === key);
  return match ? match.path : "/";
}

export function navKeyForPath(path) {
  // Exact match first, then prefix match for nested routes (e.g. /surveys/:id).
  const exact = NAV_ROUTES.find((r) => r.path === path);
  if (exact) return exact.key;
  if (path.startsWith("/surveys")) return "surveys";
  return "dashboard";
}

export default router;
